window.apisExactExportReceivablesListsDetailFormatter = function(value, row) {
    let html = '';
    let data = JSON.parse(row.data);
    if (data != null && Object.keys(data).length > 0) {
        html += '<div class="form-group">';
        html += "<label>"+__('Response')+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.data+"</textarea>";
        html += '</div>';
        html += '<div class="mt-3"></div>';
        html += '<table class="table table-borderless table-hover table-responsive table-sm table-striped text-nowrap">';
        html += '<thead>';
        html += '<tr>';
        html += '<th>'+__('Invoice Number')+'</th>';
        html += '<th>'+__('Amount')+'</th>';
        html += '</tr>';
        html += '</thead>';
        html += '<tbody>';
        data.sort((a, b) => a.InvoiceNumber.localeCompare(b.InvoiceNumber));
        for (let i = 0; i < data.length; i++) {
            let receivablesList = data[i];
            html += '<tr>';
            html += '<td>'+receivablesList.InvoiceNumber+'</td>';
            html += '<td>'+receivablesList.Amount+'</td>';
            html += '</tr>';
        }
        html += '</tbody>';
        html += '</table>';
    }
    return html;
};

